import { PIXEL_SIZE } from './shared'

export const items = {
  /**
   * WEAPONS
   */

  woodSword: {
    id: 'woodSword',
    name: 'Wood Sword',
    description: "It works as good as you'd expect.",
    icon: '/assets/wood-sword.icon.png',
    max: 1,
    equip: {
      slot: 'rItem',
      layers: {
        rItem: { url: '/assets/wood-sword.r-item.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    use: {
      kind: 'melee',
      cooldown: 0.2,
      energy: 30,
      emote: 'slash',
      sound: { name: 'melee-swing', pitch: 0.05 },
      aim: { shape: 'trap', nearDist: 0.2, nearWidth: 1.3, farDist: 1.6, farWidth: 1.3 },
      immediate: { damage: [9, 17], maxTargets: 3 },
    },
    stats: {
      defense: 0,
      crit: 5,
      speed: 0,
      energy: 0,
    },
  },
  woodAxe: {
    id: 'woodAxe',
    name: 'Wood Axe',
    description: 'A wooden axe for chopping trees.',
    icon: '/assets/wood-axe.icon.png',
    max: 1,
    equip: {
      slot: 'rItem',
      layers: {
        rItem: { url: '/assets/wood-axe.r-item.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    use: {
      kind: 'melee',
      cooldown: 0.2,
      energy: 30,
      emote: 'slash',
      sound: { name: 'melee-swing', pitch: 0.05 },
      aim: { shape: 'trap', nearDist: 0.2, nearWidth: 1.3, farDist: 1.6, farWidth: 1.3 },
      immediate: { damage: [4, 9], maxTargets: 3 },
    },
    stats: {
      defense: 0,
      crit: 2,
      speed: 0,
      energy: 0,
    },
    tool: {
      type: 'axe',
      tier: 1,
      // nah this is the same as the weapon, something weird going on here
      emote: 'slash',
      cooldown: 0.2,
      range: 0.75,
    },
  },
  woodPickaxe: {
    id: 'woodPickaxe',
    name: 'Wood Pickaxe',
    description: 'A wooden pickaxe for mining rocks.',
    icon: '/assets/wood-pickaxe.icon.png',
    max: 1,
    equip: {
      slot: 'rItem',
      layers: {
        rItem: { url: '/assets/wood-pickaxe.r-item.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    use: {
      kind: 'melee',
      cooldown: 0.2,
      energy: 30,
      emote: 'slash',
      sound: { name: 'melee-swing', pitch: 0.05 },
      aim: { shape: 'trap', nearDist: 0.2, nearWidth: 1.3, farDist: 1.6, farWidth: 1.3 },
      immediate: { damage: [3, 7], maxTargets: 3 },
    },
    stats: {
      defense: 0,
      crit: 2,
      speed: 0,
      energy: 0,
    },
    tool: {
      type: 'pickaxe',
      tier: 1,
      // nah this is the same as the weapon, something weird going on here
      emote: 'slash',
      cooldown: 0.2,
      range: 0.75,
    },
  },
  woodRod: {
    id: 'woodRod',
    name: 'Wood Rod',
    description: 'A simple fishing rod made from wood.',
    icon: '/assets/wood-rod.icon.png',
    max: 1,
    equip: {
      slot: 'rItem',
      layers: {
        rItem: { url: '/assets/wood-rod.r-item.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    use: {
      kind: 'melee',
      cooldown: 0.2,
      energy: 30,
      emote: 'slash',
      sound: { name: 'melee-swing', pitch: 0.05 },
      aim: { shape: 'trap', nearDist: 0.2, nearWidth: 1.3, farDist: 1.6, farWidth: 1.3 },
      immediate: { damage: [1, 5], maxTargets: 3 },
    },
    stats: {
      defense: 0,
      crit: 0,
      speed: 0,
      energy: 0,
    },
    tool: {
      type: 'rod',
      tier: 1,
    },
  },
  slingshot: {
    id: 'slingshot',
    name: 'Slingshot',
    description: 'Pings stones at people.',
    icon: '/assets/slingshot.icon.png',
    max: 1,
    equip: {
      slot: 'rItem',
      layers: {
        rItem: { url: '/assets/slingshot.r-item.layer.png', tint: null },
        lItem: { url: '/assets/slingshot.l-item.layer.png', tint: null },
      },
      hides: ['rHand'],
      mutes: ['lItem'],
      evicts: [],
    },
    use: {
      kind: 'ranged',
      cooldown: 0.3,
      energy: 25,
      aim: { shape: 'trap', nearDist: 0.3, nearWidth: 1, farDist: 7, farWidth: 1 },
      emote: 'loose',
      sound: { name: 'slingshot-ball', pitch: 0.1 },
      projectiles: [
        {
          delay: 0,
          radius: 0.5,
          maxDistance: 7,
          offsetDegrees: 0,
          maxTargets: 1,
          speed: 10,
          damage: [8, 14],
          flightSprite: { url: '/assets/slingshot.ball.png', yCenter: 8 * PIXEL_SIZE },
          impactSprite: { url: '/assets/puff.png', yCenter: 8 * PIXEL_SIZE, fps: 16 },
        },
      ],
    },
    stats: {
      defense: 0,
      crit: 0,
      speed: 0,
      energy: 0,
    },
  },
  bow: {
    id: 'bow',
    name: 'Bow',
    description: 'Fires arrows at range.',
    icon: '/assets/bow.icon.png',
    max: 1,
    equip: {
      slot: 'rItem',
      layers: {
        rItem: { url: '/assets/bow.r-item.layer.png', tint: null },
        lItem: { url: '/assets/bow.l-item.layer.png', tint: null },
      },
      hides: ['rHand'],
      mutes: ['lItem'],
      evicts: [],
    },
    use: {
      kind: 'ranged',
      cooldown: 0.25,
      energy: 25,
      aim: { shape: 'trap', nearDist: 0.3, nearWidth: 1, farDist: 7, farWidth: 1 },
      emote: 'loose',
      sound: { name: 'bow', pitch: 0.1 },
      projectiles: [
        {
          delay: 0,
          radius: 0.5,
          maxDistance: 7,
          offsetDegrees: 0,
          maxTargets: 1,
          speed: 14,
          damage: [9, 16],
          flightSprite: { url: '/assets/arrow.png', yCenter: 8.5 * PIXEL_SIZE },
          impactSprite: { url: '/assets/puff.png', yCenter: 8 * PIXEL_SIZE, fps: 16 },
        },
      ],
    },
    stats: {
      defense: 0,
      crit: 4,
      speed: 0,
      energy: 0,
    },
  },

  ironSword: {
    id: 'ironSword',
    name: 'Iron Sword',
    description: 'A sharp iron blade for close combat.',
    icon: '/assets/iron-sword.icon.png',
    max: 1,
    equip: {
      slot: 'rItem',
      layers: {
        rItem: { url: '/assets/iron-sword.r-item.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    use: {
      kind: 'melee',
      cooldown: 0.2,
      energy: 30,
      emote: 'slash',
      sound: { name: 'melee-swing', pitch: 0.05 },
      aim: { shape: 'trap', nearDist: 0.2, nearWidth: 1.3, farDist: 1.6, farWidth: 1.3 },
      immediate: { damage: [10, 20], maxTargets: 3 },
    },
    stats: {
      defense: 0,
      crit: 5,
      speed: 0,
      energy: 0,
    },
  },
  ironDagger: {
    id: 'ironDagger',
    name: 'Iron Dagger',
    description: 'A short blade — quick strikes and high crit chance. Pairs well with light armor.',
    icon: '/assets/iron-dagger.icon.png',
    max: 1,
    equip: {
      slot: 'rItem',
      layers: {
        rItem: { url: '/assets/iron-dagger.r-item.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    use: {
      kind: 'melee',
      cooldown: 0.15,
      energy: 20,
      emote: 'slash',
      sound: { name: 'melee-swing', pitch: 0.05 },
      aim: { shape: 'trap', nearDist: 0.2, nearWidth: 1.3, farDist: 1.2, farWidth: 1.3 },
      immediate: { damage: [8, 16], maxTargets: 1 },
    },
    stats: {
      defense: 0,
      crit: 12,
      speed: 0,
      energy: 0,
    },
  },
  ironMaul: {
    id: 'ironMaul',
    name: 'Iron Maul',
    description: 'A heavy hammer with devastating burst damage. Slow to swing.',
    icon: '/assets/iron-maul.icon.png',
    max: 1,
    equip: {
      slot: 'rItem',
      layers: {
        rItem: { url: '/assets/iron-maul.r-item.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    use: {
      kind: 'melee',
      cooldown: 0.4,
      energy: 45,
      emote: 'slash',
      sound: { name: 'melee-swing', pitch: 0.05 },
      aim: { shape: 'trap', nearDist: 0.2, nearWidth: 1.3, farDist: 1.2, farWidth: 1.3 },
      immediate: { damage: [16, 28], maxTargets: 3 },
    },
    stats: {
      defense: 0,
      crit: 3,
      speed: 0,
      energy: 0,
    },
  },
  ironAxe: {
    id: 'ironAxe',
    name: 'Iron Axe',
    description: 'Chops wood and splits skulls.',
    icon: '/assets/iron-axe.icon.png',
    max: 1,
    equip: {
      slot: 'rItem',
      layers: {
        rItem: { url: '/assets/iron-axe.r-item.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    use: {
      kind: 'melee',
      cooldown: 0.2,
      energy: 30,
      emote: 'slash',
      sound: { name: 'melee-swing', pitch: 0.05 },
      aim: { shape: 'trap', nearDist: 0.2, nearWidth: 1.3, farDist: 1.6, farWidth: 1.3 },
      immediate: { damage: [8, 16], maxTargets: 3 },
    },
    stats: {
      defense: 0,
      crit: 3,
      speed: 0,
      energy: 0,
    },
    tool: {
      type: 'axe',
      tier: 2,
      // nah this is the same as the weapon, something weird going on here
      emote: 'slash',
      cooldown: 0.2,
      range: 0.75,
    },
  },
  fireStaff: {
    id: 'fireStaff',
    name: 'Fire Staff',
    description: 'Channels fire into fireballs.',
    icon: '/assets/fire-staff.icon.png',
    max: 1,
    equip: {
      slot: 'rItem',
      layers: {
        rItem: { url: '/assets/fire-staff.r-item.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    use: {
      kind: 'magic',
      cooldown: 0.3,
      energy: 30,
      emote: 'slash',
      sound: { name: 'firestaff', pitch: 0.1 },
      aim: { shape: 'circle_aimed', radius: 1, minRange: 0, maxRange: 7 },
      projectiles: [
        {
          arc: 0.4,
          splashRadius: 1,
          maxTargets: Infinity,
          maxDistance: 7,
          speed: 5,
          damage: [8, 15],
          flightSprite: { url: '/assets/fireball.png', yCenter: 8.5 * PIXEL_SIZE, fps: 8 },
          impactSprite: { url: '/assets/puff.png', yCenter: 8 * PIXEL_SIZE, fps: 16 },
          shadowSprite: { url: '/assets/shadow.png', yCenter: 4 * PIXEL_SIZE },
        },
      ],
    },
    stats: {
      defense: 0,
      crit: 0,
      speed: 0,
      energy: 0,
    },
  },

  /**
   * Gear
   */

  // shield: {
  //   id: 'shield',
  //   name: 'Shield',
  //   description: 'Blocks incoming attacks.',
  //   icon: '/assets/shield.icon.png',
  //   max: 1,
  //   equip: {
  //     slot: 'lItem',
  //     layers: {
  //       lItem: { url: '/assets/shield.l-item.layer.png', tint: null },
  //     },
  //     hides: ['lHand'],
  //     mutes: [],
  //     evicts: [],
  //   },
  //   stats: {
  //     defense: 0,
  //     crit: 0,
  //     speed: 0,
  //     energy: 0,
  //   },
  // },
  redCape: {
    id: 'redCape',
    name: 'Red Cape',
    description: `Its a cape, and it's red.`,
    icon: '/assets/red-cape.icon.png',
    max: 1,
    equip: {
      slot: 'back',
      layers: {
        back: { url: '/assets/red-cape.back.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    stats: {
      defense: 0,
      crit: 0,
      speed: 0,
      energy: 0,
    },
  },
  // Light armor: high crit, minimal defense, no speed penalty. Glass cannon.
  // Full set: defense 1, crit 20%, speed 0.
  clothHood: {
    id: 'clothHood',
    name: 'Cloth Hood',
    description: 'A cozy hood.',
    icon: '/assets/cloth-hood.icon.png',
    max: 1,
    equip: {
      slot: 'head',
      layers: {
        head: { url: '/assets/cloth-hood.head.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    stats: {
      defense: 0,
      crit: 6,
      speed: 0,
      energy: 0,
    },
  },
  clothVest: {
    id: 'clothVest',
    name: 'Cloth Vest',
    description: 'A light snug vest made of cloth.',
    icon: '/assets/cloth-vest.icon.png',
    max: 1,
    equip: {
      slot: 'chest',
      layers: {
        chest: { url: '/assets/cloth-vest.chest.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    stats: {
      defense: 1,
      crit: 8,
      speed: 0,
      energy: 0,
    },
  },
  clothLeggings: {
    id: 'clothLeggings',
    name: 'Cloth Leggings',
    description: 'Light comfortable leggings.',
    icon: '/assets/cloth-leggings.icon.png',
    max: 1,
    equip: {
      slot: 'legs',
      layers: {
        legs: { url: '/assets/cloth-leggings.legs.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    stats: {
      defense: 0,
      crit: 6,
      speed: 0,
      energy: 0,
    },
  },
  // Medium armor: balanced crit + defense, no speed penalty. All-rounder.
  // Full set: defense 4, crit 10%, speed 0.
  leatherCowl: {
    id: 'leatherCowl',
    name: 'Leather Cowl',
    description: 'A leather cowl.',
    icon: '/assets/leather-cowl.icon.png',
    max: 1,
    equip: {
      slot: 'head',
      layers: {
        head: { url: '/assets/leather-cowl.head.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    stats: {
      defense: 1,
      crit: 3,
      speed: 0,
      energy: 0,
    },
  },
  leatherTop: {
    id: 'leatherTop',
    name: 'Leather Top',
    description: 'A fitted leather jerkin. Light but durable.',
    icon: '/assets/leather-top.icon.png',
    max: 1,
    equip: {
      slot: 'chest',
      layers: {
        chest: { url: '/assets/leather-top.chest.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    stats: {
      defense: 2,
      crit: 4,
      speed: 0,
      energy: 0,
    },
  },
  leatherPants: {
    id: 'leatherPants',
    name: 'Leather Pants',
    description: 'Tough leather leggings offering basic protection.',
    icon: '/assets/leather-pants.icon.png',
    max: 1,
    equip: {
      slot: 'legs',
      layers: {
        legs: { url: '/assets/leather-pants.legs.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    stats: {
      defense: 1,
      crit: 3,
      speed: 0,
      energy: 0,
    },
  },
  // Heavy armor: high defense + small crit, speed penalty on chestplate.
  // Full set: defense 6, crit 6%, speed -1.
  ironHelm: {
    id: 'ironHelm',
    name: 'Iron Helm',
    description: 'A helmet made of strong iron.',
    icon: '/assets/iron-helm.icon.png',
    max: 1,
    equip: {
      slot: 'head',
      layers: {
        head: { url: '/assets/iron-helm.head.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    stats: {
      defense: 2,
      crit: 2,
      speed: 0,
      energy: 0,
    },
  },
  ironChestplate: {
    id: 'ironChestplate',
    name: 'Iron Chestplate',
    description: 'An iron chestplate. Strong and defensive.',
    icon: '/assets/iron-chestplate.icon.png',
    max: 1,
    equip: {
      slot: 'chest',
      layers: {
        chest: { url: '/assets/iron-chestplate.chest.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    stats: {
      defense: 2,
      crit: 2,
      speed: -1,
      energy: 0,
    },
  },
  ironLeggings: {
    id: 'ironLeggings',
    name: 'Iron Leggings',
    description: 'Strong leggings made of iron.',
    icon: '/assets/iron-leggings.icon.png',
    max: 1,
    equip: {
      slot: 'legs',
      layers: {
        legs: { url: '/assets/iron-leggings.legs.layer.png', tint: null },
      },
      hides: [],
      mutes: [],
      evicts: [],
    },
    stats: {
      defense: 2,
      crit: 2,
      speed: 0,
      energy: 0,
    },
  },

  blueHoodie: {
    id: 'blueHoodie',
    name: 'Blue Hoodie',
    description: `It's a blue hoodie.`,
    icon: '/assets/blue-hoodie.icon.png',
    max: 1,
    equip: {
      slot: 'chest',
      layers: {
        chest: { url: '/assets/blue-hoodie.chest.layer.png', tint: null },
      },
      hides: ['head'],
      mutes: [],
      evicts: [],
    },
    stats: {
      defense: 0,
      crit: 5,
      speed: 1,
      energy: 0,
    },
  },

  /**
   * Misc
   */

  apple: {
    id: 'apple',
    name: 'Apple',
    description: 'A crisp apple. Restores health when eaten.',
    icon: '/assets/apple.icon.png',
    max: 20,
    consumable: {
      health: 50,
      cooldown: 0.2,
      sound: { name: 'eat', pitch: 0.1 },
    },
  },
  strawberry: {
    id: 'strawberry',
    name: 'Strawberry',
    description: 'A yummy strawberry. Restores health when eaten.',
    icon: '/assets/strawberry.icon.png',
    max: 20,
    consumable: {
      health: 50,
      cooldown: 0.2,
      sound: { name: 'eat', pitch: 0.1 },
    },
  },
  fishRaw: {
    id: 'fishRaw',
    name: 'Raw Fish',
    description: 'A freshly caught fish.',
    icon: '/assets/fish.raw.icon.png',
    max: 20,
  },
  fishCooked: {
    id: 'fishCooked',
    name: 'Cooked Fish',
    description: 'Cooked over a fire. Restores health.',
    icon: '/assets/fish.cooked.icon.png',
    max: 20,
    consumable: {
      health: 50,
      cooldown: 0.2,
      sound: { name: 'eat', pitch: 0.1 },
    },
  },
  log: {
    id: 'log',
    name: 'Log',
    description: 'Sturdy timber from a tree.',
    icon: '/assets/log.icon.png',
    max: 20,
  },
  stick: {
    id: 'stick',
    name: 'Stick',
    description: 'A stick, might be useful.',
    icon: '/assets/stick.png',
    max: 20,
  },
  stone: {
    id: 'stone',
    name: 'Stone',
    description: 'A chunk of stone, useful for crafting.',
    icon: '/assets/stone.png',
    max: 20,
  },
  hide: {
    id: 'hide',
    name: 'Hide',
    description: 'A rough animal hide.',
    icon: '/assets/hide.icon.png',
    max: 20,
  },
  leather: {
    id: 'leather',
    name: 'Leather',
    description: 'A nice piece of leather.',
    icon: '/assets/leather.icon.png',
    max: 20,
  },
  ironOre: {
    id: 'ironOre',
    name: 'Iron Ore',
    description: 'Raw iron ore.',
    icon: '/assets/iron-ore.icon.png',
    max: 20,
  },
  ironBar: {
    id: 'ironBar',
    name: 'Iron Bar',
    description: 'A smelted iron bar, ready for crafting.',
    icon: '/assets/iron-bar.icon.png',
    max: 20,
  },
  cotton: {
    id: 'cotton',
    name: 'Cotton',
    description: 'A ball of cotton.',
    icon: '/assets/cotton.png',
    max: 20,
  },
}
